export default __webpack_public_path__ + "static/media/747.e6103a3c.gif";